/**
 * 页面路由，路由是浏览器端和服务器端共用的部分
 */
// import FAQ from './cmps/FAQ';
// import Jobs from './cmps/jobs';
import Backtone from './cmps/backtone';
import Exame from './cmps/online-written-exame';
import Evaluation from './cmps/online-evaluation';
import Home from './cmps/home';
export default [
    {
        path: '/pages/:domain/backtone',
        component: Backtone
    },
    {
        path: '/pages/:domain/exame',
        component: Exame
    },
    {
        path: '/pages/:domain/evaluation',
        component: Evaluation
    },
    {
        path: '/pages/:domain/',
        component: Home
    }
];